import { Dialog, Transition } from '@headlessui/react'
import React, { Fragment } from 'react'
import ButtonPrimary from '../uiComponents/buttons/ButtonPrimary'
import CalendarIcon2 from '../uiComponents/icons/CalendarIcon2'
import CloseIcon from '../uiComponents/icons/CloseIcon'

const QuickTipModal = ({ quickTipModal, setQuickTipModal }) => {
    return (
        <Transition appear show={quickTipModal} as={Fragment}>
            <Dialog as="div" className="relative z-[999]" onClose={() => setQuickTipModal(false)}>
                <Transition.Child
                    as={Fragment}
                    enter="ease-out duration-300"
                    enterFrom="opacity-0"
                    enterTo="opacity-100"
                    leave="ease-in duration-200"
                    leaveFrom="opacity-100"
                    leaveTo="opacity-0">
                    <div className="fixed inset-0 bg-dark-950 bg-opacity-70" />
                </Transition.Child>
                <div className="fixed inset-0 overflow-y-auto">
                    <div className="flex min-h-full items-center justify-center p-4 text-center">
                        <Transition.Child
                            as={Fragment}
                            enter="ease-out duration-300"
                            enterFrom="opacity-0 scale-95"
                            enterTo="opacity-100 scale-100"
                            leave="ease-in duration-200"
                            leaveFrom="opacity-100 scale-100"
                            leaveTo="opacity-0 scale-95">
                            <Dialog.Panel className="w-full max-w-[560px] transform rounded-[10px] bg-white lg:p-6 p-4 text-start align-middle shadow-110 transition-all">
                                <div className="modal-header mb-2">
                                    <h2 className="font-semibold text-xl text-center text-blue-950">Quick Tip</h2>
                                    <button
                                        type={"button"}
                                        aria-label="button"
                                        className="inline-block absolute right-3 top-3 ms-auto outline-[0px]"
                                        onClick={() => setQuickTipModal(false)}>
                                        <CloseIcon className="w-5 h-5 text-blue-950/50" />
                                    </button>
                                </div>
                                <div className="modal-body">
                                    <div className="text-[15px] mx-auto text-center text-dark-650 font-medium md:max-w-[85%]">
                                        <p className="leading-[1.6] mb-3.5">You can transfer bookings from your old calendar to your new Mee Time calendar now</p>
                                        <ButtonPrimary size={"sm"} className={"xsm:max-w-[200px] w-full mx-auto mb-3.5"} children={"Sync"} icon={<span><CalendarIcon2 className="w-6 h-6" /></span>} />
                                        <p className='mb-3.5'>Or</p>
                                        <p className="mb-3.5 leading-[1.6] ">Do it later by going to “Calendar & Booking” (in your menu), by using the “Sync” button in your calendar ovevriew</p>
                                        <ButtonPrimary size={"sm"} className={"xsm:max-w-[200px] w-full mx-auto"} children={"Got It"} />
                                    </div>
                                </div>
                            </Dialog.Panel>
                        </Transition.Child>
                    </div>
                </div>
            </Dialog>
        </Transition>
    )
}

export default QuickTipModal